import { CSSProperties } from 'react';
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export interface CSSVarBanner extends CSSProperties {
  '--bgcolor': string;
}

export interface CSSVarButton extends CSSProperties {
  '--buttonBgColor': string;
  '--buttonTextColor': string;
}

export interface CSSVarLegal extends CSSProperties {
  '--color': string;
}

export interface CSSVarImage extends CSSProperties {
  '--bgDesktop': string;
  '--bgMobile': string;
}

const { fonts, spacing } = theme;

export const HeroBannerWrapper = css`
  position: relative;
`;

export const HeroBannerLink = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const HeroBannerButton = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: 600;
  font-size: 14px;
  border: 0 none;
  background: var(--buttonBgColor);
  border-radius: 3px;
  color: var(--buttonTextColorMode);
  padding: 18px 25px;
  letter-spacing: normal;
  font-style: normal;
  font-stretch: normal;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
  margin-top: ${pxToRem(spacing.sm)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-top: ${pxToRem(spacing.xl)};
    `,
  )};
`;

export const HeroBannerPromo = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${pxToRem(230)};
  background: var(--bgcolor);
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      height: 100%;
    `,
  )};
`;

export const HeroBannerPromoContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 20px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: 24px 0;
    `,
  )};

  > img {
    max-width: 100%;
    height: auto;
    margin: 0 auto ${pxToRem(spacing.xl)};
  }
`;

export const TandCs = css`
  text-align: center;
  display: inline-block;
  z-index: 1;
  margin: 14px 0 8px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 12px 0 0;
    `,
  )};

  > a {
    display: block;
    color: var(--color);
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-size: 11px;
    text-decoration: none;
    font-weight: 600;
  }
`;

export const HeroBannerImage = css`
  background-image: var(--bgMobile);
  background-repeat: none;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 60vw;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      background-image: var(--bgDesktop);
      height: 100%;
    `,
  )};
`;

export const TitleImageDesktop = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: block;
    `,
  )};
`;

export const TitleImageMobile = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: none;
    `,
  )};
`;

export const PictureContainer = css`
  height: ${pxToRem(235)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      height: ${pxToRem(300)};
    `,
  )};
`;
